import React from 'react'
import Headertop from '../components/Headertop'
import Header from '../components/Header'
import Servicestopbar from '../components/Servicestopbar'
import Footer from '../components/Footer'
import './stylesheets/home.css'
import imgnode from '../components/node-logo.png'
import imgnative from '../components/react-native-logo.svg'
import webdevimg from '../components/web-dev-logo.jpg'
import finimg from '../components/finance-logo.jpg'
import gamedevlogo from '../components/game-dev-logo.jpg'
import { useEffect, useState } from 'react';

function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const showSlide = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  const slides = [
    'https://i.imgur.com/weXVL8M.jpg',
    'https://i.imgur.com/Rpxx6wU.jpg',
    'https://i.imgur.com/83fandJ.jpg',
    'https://i.imgur.com/JiQ9Ppv.jpg',
  ];

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div>
      <Headertop />
      <Header />
      <Servicestopbar />
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <figure className="card card-product-grid card-lg">
              <a href="#" className="img-wrap" data-abc="true"><img src={imgnode} /></a>
              <figcaption className="info-wrap">
                <div className="row prodet">
                  <div className="col-md-8">
                    <a href="#" className="title" data-abc="true">NODE REACT WEB APP</a>
                  </div>
                  <div className="col-md-4">
                    <div className="rating text-right">
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                    </div>
                  </div>
                </div>
              </figcaption>
              <div className="bottom-wrap">
                <a href="#" className="btn  btn-primary float-right" data-abc="true"> VIEW </a>
                <div className="price-wrap">
                  <span className="price h5">$999</span> <br /> <small className="text-success">20% DISCOUNT</small>
                </div>
              </div>
            </figure>
          </div>
          <div className="col-md-4">
            <figure className="card card-product-grid card-lg">
              <a href="#" className="img-wrap" data-abc="true"><img src={imgnative} /></a>
              <figcaption className="info-wrap">
                <div className="row prodet">
                  <div className="col-md-8">
                    <a href="#" className="title" data-abc="true">REACT NATIVE APP DEVELOPER</a>
                  </div>
                  <div className="col-md-4">
                    <div className="rating text-right">
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                    </div>
                  </div>
                </div>
              </figcaption>
              <div className="bottom-wrap">
                <a href="#" className="btn  btn-primary float-right" data-abc="true"> book now </a>
                <div className="price-wrap">
                  <span className="price h5">$999</span> <br /> <small className="text-success">Free revision</small>
                </div>
              </div>
            </figure>
          </div>
          <div className="col-md-4">
            <figure className="card card-product-grid card-lg">
              <a href="#" className="img-wrap" data-abc="true"><img src={webdevimg} /></a>
              <figcaption className="info-wrap">
                <div className="row prodet">
                  <div className="col-md-8">
                    <a href="#" className="title" data-abc="true">WEB DEVELOPERS</a>
                  </div>
                  <div className="col-md-4">
                    <div className="rating text-right">
                      <i className="fa fa-star"></i>
                    </div>
                  </div>
                </div>
              </figcaption>
              <div className="bottom-wrap">
                <a href="#" className="btn  btn-primary float-right" data-abc="true"> visit </a>
                <div className="price-wrap">
                  <span className="price h5">$799</span> <br /> <small className="text-success">incentivized</small>
                </div>
              </div>
            </figure>
          </div>
          <div className="col-md-4">
            <figure className="card card-product-grid card-lg">
              <a href="#" className="img-wrap" data-abc="true"><img src={finimg} /></a>
              <figcaption className="info-wrap">
                <div className="row prodet">
                  <div className="col-md-8">
                    <a href="#" className="title" data-abc="true">FINANCIAL ACCOUNTANTS</a>
                  </div>
                  <div className="col-md-4">
                    <div className="rating text-right">
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                    </div>
                  </div>
                </div>
              </figcaption>
              <div className="bottom-wrap">
                <a href="#" className="btn  btn-primary float-right" data-abc="true"> get audit report now </a>
                <div className="price-wrap">
                  <span className="price h5">$1999</span> <br /> <small className="text-success">fast service</small>
                </div>
              </div>
            </figure>
          </div>
          <div className="col-md-4">
            <figure className="card card-product-grid card-lg">
              <a href="#" className="img-wrap" data-abc="true"><img src={gamedevlogo} /></a>
              <figcaption className="info-wrap">
                <div className="row prodet">
                  <div className="col-md-8">
                    <a href="#" className="title" data-abc="true">PROFFESIONAL GAME DEVELOPERS</a>
                  </div>
                  <div className="col-md-4">
                    <div className="rating text-right">
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                    </div>
                  </div>
                </div>
              </figcaption>
              <div className="bottom-wrap">
                <a href="#" className="btn  btn-primary float-right" data-abc="true"> view </a>
                <div className="price-wrap">
                  <span className="price h5">$899</span> <br /> <small className="text-success">remarkable</small>
                </div>
              </div>
            </figure>
          </div>
          {/* <div className="col-md-4">
            <figure className="card card-product-grid card-lg">
              <a href="#" className="img-wrap" data-abc="true"><img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1571750967/Ecommerce/ef192a21ec96.jpg" /></a>
              <figcaption className="info-wrap">
                <div className="row prodet">
                  <div className="col-md-8">
                    <a href="#" className="title" data-abc="true">Dell Laptop - 5GB RAM</a>
                  </div>
                  <div className="col-md-4">
                    <div className="rating text-right">
                      <i className="fa fa-star"></i>
                      <i className="fa fa-star"></i>
                    </div>
                  </div>
                </div>
              </figcaption>
              <div className="bottom-wrap">
                <a href="#" className="btn  btn-primary float-right" data-abc="true"> Buy now </a>
                <div className="price-wrap">
                  <span className="price h5">$599</span> <br /> <small className="text-success">Free shipping</small>
                </div>
              </div>
            </figure>
          </div> */}
        </div>
      </div>
      <section class="services">
        <div class="container">
            <div class="row justify-content-center">
                {/* <!-- section title --> */}
                <div class="col-xl-6 col-lg-8">
                    <div class="title text-center">
                        <h2>Our Services</h2>
                        <p>Vestibulum nisl tortor, consectetur quis imperdiet bibendum, laoreet sed arcu. Sed
                            condimentum iaculis ex,
                            in faucibus lorem accumsan non. Donec mattis tincidunt metus. Morbi sed tortor a risus
                            luctus dignissim.</p>
                        <div class="border"></div>
                    </div>
                </div>
                {/* <!-- /section title --> */}
            </div>
            <div class="row no-gutters">

                {/* <!-- Single Service Item --> */}
                <div class="col-lg-4 col-sm-6 mb-4 mb-lg-0">
                    <div class="service-block p-4 color-bg text-center">
                        <div class="service-icon text-center">
                            <i class="fa-regular fa-clone"></i>
                        </div>
                        <h3>WordPress Theme</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur.. Sed id lorem eget orci dictum facilisis vel id
                            tellus. Nullam
                            iaculis arcu at mauris dapibus consectetur.</p>
                    </div>
                </div>
                {/* <!-- End Single Service Item --> */}

                {/* <!-- Single Service Item --> */}
                <div class="col-lg-4 col-sm-6 mb-4 mb-lg-0">
                    <div class="service-block p-4 text-center">
                        <div class="service-icon text-center">
                            <i class="fa-regular fa-clock"></i>
                        </div>
                        <h3>Responsive Design</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur.. Sed id lorem eget orci dictum facilisis vel id
                            tellus. Nullam
                            iaculis arcu at mauris dapibus consectetur.</p>
                    </div>
                </div>
                {/* <!-- End Single Service Item --> */}

                {/* <!-- Single Service Item --> */}
                <div class="col-lg-4 col-sm-6 mb-4 mb-lg-0">
                    <div class="service-block p-4 color-bg text-center">
                        <div class="service-icon text-center">
                            <i class="fa-solid fa-book"></i>
                        </div>
                        <h3>Media & Advertisement</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur.. Sed id lorem eget orci dictum facilisis vel id
                            tellus. Nullam
                            iaculis arcu at mauris dapibus consectetur.</p>
                    </div>
                </div>
                {/* <!-- End Single Service Item --> */}

                {/* <!-- Single Service Item --> */}
                <div class="col-lg-4 col-sm-6 mb-4 mb-lg-0">
                    <div class="service-block p-4  text-center">
                        <div class="service-icon text-center">
                            <i class="fa-solid fa-briefcase"></i>
                        </div>
                        <h3>Graphic Design</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur.. Sed id lorem eget orci dictum facilisis vel id
                            tellus. Nullam
                            iaculis arcu at mauris dapibus consectetur.</p>
                    </div>
                </div>
                {/* <!-- End Single Service Item --> */}

                {/* <!-- Single Service Item --> */}
                <div class="col-lg-4 col-sm-6 mb-4 mb-lg-0">
                    <div class="service-block p-4 color-bg text-center">
                        <div class="service-icon text-center">
                            <i class="fa-solid fa-crop"></i>
                        </div>
                        <h3>Apps Development</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur.. Sed id lorem eget orci dictum facilisis vel id
                            tellus. Nullam
                            iaculis arcu at mauris dapibus consectetur.</p>
                    </div>
                </div>
                {/* <!-- End Single Service Item --> */}

                {/* <!-- Single Service Item --> */}
                <div class="col-lg-4 col-sm-6 mb-4 mb-lg-0">
                    <div class="service-block p-4 text-center">
                        <div class="service-icon text-center">
                            <i class="fa-solid fa-house-user"></i>
                        </div>
                        <h3>Networking</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur.. Sed id lorem eget orci dictum facilisis vel id
                            tellus. Nullam
                            iaculis arcu at mauris dapibus consectetur.</p>
                    </div>
                </div>
                {/* <!-- End Single Service Item --> */}

            </div>  {/* <!-- End row --> */}
        </div> {/* <!-- End container --> */}
    </section>
      <Footer />
    </div>
  )
}

export default Home
